export const parseStringified = <T>(text?: string): T | undefined => {
  try {
    const res = text && JSON.parse(text);

    return res ?? undefined;
  } catch {
    return undefined;
  }
};
